<template>
  <slide-view v-model:toggle="editor.active.menu.toggle">
    <a-menu :items="menu" :inline-collapsed="editor.active.menu.toggle"
            v-model:selected-keys="editor.active.menu.selectedKeys" mode="inline"/>
    <a-divider/>

    <a-flex v-if="editor.active.menu.items.filter(i => !i.lock).length" justify="center">
      <a-button :icon="h(SettingOutlined)" @click="onMenuShow"/>
    </a-flex>
    <a-modal v-model:open="info.open" title="订制业务" :footer="null"
             :cancel-button-props="{style:{display: 'none'}}">
      <a-flex wrap="wrap" gap="middle" class="menu-custom">
        <div v-for="(c,index) in editor.active.menu.items" :key="c.business!.kind" :draggable="!c.lock"
             @dragstart="onDragStart($event,index)" @dragenter="onDragEnter($event,index)" @dragend="onDragEnd"
             @dragover="onDragOver"
             :style="{width: '228px', cursor: c.lock ? 'no-drop' : 'move'}">
          <module-item-view :title="c.label" :name="c.business!.kind" :description="c.description" :must="c.lock"
                            :checked="c.business!.enabled"
                            @on-checked="(_,checked:boolean) => c.business!.enabled = checked"/>
        </div>
      </a-flex>

    </a-modal>
  </slide-view>
</template>

<script setup lang="ts">

import SlideView from "@/views/share/SlideView.vue";
import {computed, h, onMounted, onUnmounted, reactive} from "vue";
import {useRoute} from "vue-router";
import {AEditor} from "@/model/editor";
import {SettingOutlined} from "@ant-design/icons-vue";
import ModuleItemView from "@/views/activity/components/ModuleItemView.vue";
import emit from "@/lib/emit";

const editor = useRoute().meta.editor as AEditor;
const info = reactive({open: false, dragPosition: 0})

const menu = computed(() => {
  return editor.active.menu.items.filter(i => !i.business || i.business.enabled)
})

onMounted(() => {
  emit.on('editor.menu.custom', onMenuShow);
  emit.on('window.resize',windowSizeChange)
  windowSizeChange();
})

onUnmounted(() => {
  emit.off('editor.menu.custom', onMenuShow);
  emit.off('window.resize',windowSizeChange)
})

const windowSizeChange = () => {
  if (window.innerWidth < 1600 && !editor.active.menu.toggle) editor.active.menu.toggle = true;
  else if (window.innerWidth > 1600 && editor.active.menu.toggle) editor.active.menu.toggle = false;
}

const onMenuShow = () => info.open = true

const onDragStart = (ev: DragEvent, i: number) => {
  // console.log('onDragStart',ev, i)
  ev.stopPropagation()
  // ev.target instanceof HTMLInputElement ? ev.target.style.cursor = 'move' : null
  info.dragPosition = i
  setTimeout(() => (ev.target as HTMLImageElement).classList.add('moving'), 0)
}

const onDragEnter = (ev: DragEvent, i: number) => {
  // console.log('onDragEnter', i, this.arr)
  ev.preventDefault()
  if (info.dragPosition != i) {
    const s = editor.active.menu.items[info.dragPosition]
    const t = editor.active.menu.items[i]
    if (t.lock) return
    editor.active.menu.items.splice(i, 1, s)
    editor.active.menu.items.splice(info.dragPosition, 1, t)
    info.dragPosition = i
  }
}

const onDragEnd = (ev: DragEvent) => {
  (ev.target as HTMLImageElement).classList.remove('moving')
}

const onDragOver = (ev: DragEvent) => {
  ev.preventDefault()
  if (ev.dataTransfer) ev.dataTransfer.dropEffect = 'move'
}
</script>

<style scoped lang="sass">
.ant-menu
  margin-top: 12px

  :deep(.anticon)
    padding: 4px
    background-color: rgba(0, 0, 0, 0.06)
    border-radius: 6px

  :deep(.ant-menu-item)
    //border: 1px solid #f1f1f1
    margin-top: 6px

.menu-custom
  > .moving
    opacity: 0.1

</style>